import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const MapMarker = createSvgIcon(
  <>
    <path d="M22.2433 12.605L12.614 22.2422L14.3707 24.0004L24 14.3632L22.2433 12.605Z" />
    <path d="M21.0194 11.3753L17.8175 8.19031C18.393 7.00369 18.5396 5.65403 18.2323 4.37135C17.925 3.08867 17.1827 1.95234 16.132 1.15604C15.0813 0.359729 13.7872 -0.0472793 12.4702 0.00437549C11.1533 0.0560302 9.89497 0.563151 8.90976 1.43931C7.86869 1.01092 6.72426 0.900294 5.6205 1.12134C4.51675 1.34239 3.50298 1.88524 2.70677 2.68158C1.91057 3.47792 1.3675 4.49216 1.14591 5.59668C0.92432 6.7012 1.03411 7.84664 1.46146 8.88885C0.576605 9.87388 0.0617544 11.1363 0.00520861 12.4597C-0.0513372 13.7831 0.353945 15.0849 1.15155 16.142C1.94915 17.199 3.08938 17.9453 4.37668 18.253C5.66398 18.5607 7.01813 18.4106 8.20691 17.8283L11.3893 21.0084L21.0194 11.3753Z" />
  </>,
  'MapMarker'
)

export default MapMarker
